<template>
  <button @click="getAppleToken">
    <slot>
      <sns-logo-circle sns-name="apple" :width="44" :height="44" />
    </slot>
    <span class="a11y-hidden">Apple ID로 시작하기</span>
  </button>
</template>

<script setup>
  import SnsLogoCircle from '@/components/connection/sns/SnsLogoCircle.vue'
  import { setLibFile } from '@/common/plugins/sns.lib'
  import { onMounted } from 'vue'
  import { useRoute } from 'vue-router/composables'
  import { URL_COOKIE_DOMAIN } from '@/common/constant'
  import utils from '@/common/util/utils'

  const props = defineProps({
    useMemberWeb: {
      type: Boolean,
      default: false,
    },
    returnUrl: {
      type: String,
      default: location.href,
    },
  })

  const emit = defineEmits(['success', 'fail'])
  const route = useRoute()

  const getAppleToken = () => {
    if (props.useMemberWeb) {
      const loginUrl = utils.login.getMemberSnsLoginUrl({
        type: 'apple',
        callback: location.href,
      })
      location.href = loginUrl
      return
    }
    AppleID.auth.init({
      clientId: 'kr.co.captv.pooqV2.member',
      scope: 'email',
      redirectURI: 'https://member.wavve.com/mobile/signup/mweb/apple',
      // response
      state: '',
      usePopup: false, // or false defaults to false
    })
    utils.cookies.setItem(
      'w-apple-login-return-url',
      props.returnUrl,
      null,
      URL_COOKIE_DOMAIN,
      '/',
    )
    AppleID.auth.signIn()
  }

  const sdkInit = () => {
    setLibFile(
      document,
      'script',
      'apple-login',
      '//appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/ko_KR/appleid.auth.js',
    )
  }

  onMounted(() => {
    const { type, token } = route.query
    if (type === 'apple') {
      if (token) {
        emit('success', { token })
      } else {
        emit('fail', { message: 'Failed to get token' })
      }
    }
    if (props.useMemberWeb) {
      return
    }
    sdkInit()
  })
</script>
